import { Component, OnInit } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { ListItem, QualityControlDirt, RepositoryModal } from '../../../shared'
import { DirtComponent } from './dirt.component'

@Component({
    templateUrl: './dirt-modal.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule],
})
export class DirtModalComponent extends RepositoryModal<QualityControlDirt> implements OnInit {
    vendorOptions: ListItem<number | null>[] = []
    testingCompanyOptions: ListItem<number | null>[] = []

    ngOnInit() {
        const parentComponent = this.editOptions.initializeParams as DirtComponent

        // Build vendor options (aggregate vendors)
        this.vendorOptions = []
        this.vendorOptions.push(new ListItem<number | null>(null, 'Select a Vendor'))
        parentComponent.aggregateVendors.forEach(x => {
            this.vendorOptions.push(new ListItem<number | null>(x.id, x.name))
        })

        // Build testing company options (all vendors), sorted alphabetically by name
        const allVendorsSorted = [...parentComponent.allVendors].sort((a, b) => (a.name || '').localeCompare(b.name || ''))
        this.testingCompanyOptions = []
        this.testingCompanyOptions.push(new ListItem<number | null>(null, 'Select a Testing Company'))
        allVendorsSorted.forEach(x => {
            this.testingCompanyOptions.push(new ListItem<number | null>(x.id, x.name))
        })

        if (this.isAdding) {
            // Set default job from parent
            this.target.job = parentComponent.selectedJob()
        }
    }

    protected onBeforeSave(): boolean {
        if (!this.target.job) {
            this.services.notification.warning('Job is required')
            return false
        }
        return true
    }
}
